import { AxiosResponse } from 'axios';
import { buildPath } from '../lib/url';
import { backendClient as client } from './clients';
import { TagReadDTO, TagUpdateDTO } from './dto';
import { CreateOne, GetManyPaged, GetManyUnpaged, RequestMethod } from './types';

export const TAGS_PATH = 'tags';

export const getActivityTags: GetManyUnpaged<{ activityId: number }, TagReadDTO> = async ({ activityId, config }) =>
    client.get(buildPath([TAGS_PATH, 'activity', activityId]), config).then((response: AxiosResponse) => response.data);

export const createTag: CreateOne<{ activityId?: number; data: TagUpdateDTO }, TagReadDTO> = async ({
    activityId,
    data,
    config,
}) =>
    client
        .post(buildPath(activityId ? [TAGS_PATH, 'create', activityId] : [TAGS_PATH, 'create']), data, config)
        .then((response: AxiosResponse) => response.data);

export const tagActivity: RequestMethod<{ id: number; tagName: string }, any> = async ({ id, tagName, config }) =>
    client
        .post(buildPath([TAGS_PATH, 'tag', id]), {}, { ...config, params: { tagName: tagName } })
        .then((response: AxiosResponse) => response.data);

export const untagActivity: RequestMethod<{ activityId: number; tagId: number }, any> = async ({
    activityId,
    tagId,
    config,
}) =>
    client
        .get(buildPath([TAGS_PATH, 'untag', activityId, tagId]), config)
        .then((response: AxiosResponse) => response.data);

export const getTags: GetManyPaged<TagReadDTO> = async ({ filter, page, size, sort, config } = {}) =>
    client
        .get(buildPath([TAGS_PATH]), { ...config, params: { filter, page, size, sort } })
        .then((response: AxiosResponse) => response.data);

export const getSelectableTags: GetManyPaged<TagReadDTO> = async ({ filter, page, size, sort, config } = {}) =>
    client
        .get(buildPath([TAGS_PATH, 'selectable']), { ...config, params: { filter, page, size, sort } })
        .then((response: AxiosResponse) => response.data);
